import React from "react";
import TextField from "@mui/material/TextField";
import { AiOutlineExclamation } from "react-icons/ai";
import { useRouter } from "next/router";
import useSubscriptionForm from "hooks/forms/useSubscriptionForm";
import { addEmail } from "api/emails.api";
import Button from "components/button/Button";
import useDarkMode from "hooks/useDarkMode";

const Subscription = () => {
  const router = useRouter();
  const { theme } = useDarkMode();
  const isDark = theme === "dark";
  const { values, errors, submitForm, setFieldValue } =
    useSubscriptionForm(addEmail);

  return (
    <div
      className={`flex flex-col gap-5 md:gap-6 p-4 sm:p-6 md:p-10 text-center w-full max-w-2xl transition-all duration-300 rounded-2xl md:rounded-[24px] mb-6 ${
        isDark
          ? "bg-[#030014]/60 backdrop-blur-xl border border-cyan-500/20 shadow-[0_0_30px_rgba(102,133,255,0.05)]"
          : "bg-white/80 backdrop-blur-md border border-slate-200 shadow-md"
      }`}
    >
      <span
        className={`text-xl sm:text-2xl font-sans font-black tracking-tight ${
          isDark
            ? "text-cyan-50 drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]"
            : "text-slate-900"
        }`}
      >
        Բաժանոդրագրվեք մեր փոստային ցանկին
      </span>
      <div className="flex flex-col gap-4 p-2 sm:p-4">
        <TextField
          placeholder="Անուն"
          fullWidth
          value={values.name}
          onChange={(e) => setFieldValue("name", e.target.value)}
        />

        <TextField
          placeholder="Էլ․ հասցե"
          type="email"
          autoComplete="off"
          fullWidth
          value={values.email}
          onChange={(e) => setFieldValue("email", e.target.value)}
        />
        <div
          className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
            isDark
              ? "bg-cyan-950/20 border border-cyan-500/20"
              : "bg-slate-50 border border-slate-200"
          }`}
        >
          <div
            className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
              isDark
                ? "bg-cyan-500/20 shadow-[0_0_10px_rgba(102,133,255,0.2)] text-cyan-400"
                : "bg-cyan-100 text-cyan-600"
            }`}
          >
            <AiOutlineExclamation size={18} />
          </div>
          <span
            className={`text-[14px] w-fit text-left leading-relaxed ${
              isDark ? "text-slate-300" : "text-slate-600"
            }`}
          >
            Բաժանորդագվելով՝ դուք համաձայնվում եք մեր{" "}
            <button
              onClick={() => router.push("/privacy-policy")}
              className={`underline cursor-pointer transition-colors ${
                isDark
                  ? "text-cyan-400 hover:text-cyan-300"
                  : "text-cyan-600 hover:text-cyan-700"
              }`}
            >
              գաղտնիության քաղաքականությանը{" "}
            </button>{" "}
            և ընդունում եք{" "}
            <button
              onClick={() => router.push("/terms-of-use")}
              className={`underline cursor-pointer transition-colors ${
                isDark
                  ? "text-cyan-400 hover:text-cyan-300"
                  : "text-cyan-600 hover:text-cyan-700"
              }`}
            >
              պայմաններն ու դրույթները
            </button>
          </span>
        </div>
        <Button onClick={() => submitForm()} className="w-full text-lg mt-2">
          Բաժանորդագվել
        </Button>
        {Boolean(errors.name) && (
          <div
            className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
              isDark
                ? "bg-red-950/20 border border-red-500/20"
                : "bg-red-50 border border-red-200"
            }`}
          >
            <div
              className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
                isDark
                  ? "text-red-400 bg-red-500/20 shadow-[0_0_10px_rgba(239,68,68,0.2)]"
                  : "text-red-500 bg-red-100"
              }`}
            >
              <AiOutlineExclamation size={18} />
            </div>
            <span
              className={`text-[14px] w-fit text-left ${isDark ? "text-red-200" : "text-red-600"}`}
            >
              {errors.name}
            </span>
          </div>
        )}
        {Boolean(errors.email) && (
          <div
            className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
              isDark
                ? "bg-red-950/20 border border-red-500/20"
                : "bg-red-50 border border-red-200"
            }`}
          >
            <div
              className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
                isDark
                  ? "text-red-400 bg-red-500/20 shadow-[0_0_10px_rgba(239,68,68,0.2)]"
                  : "text-red-500 bg-red-100"
              }`}
            >
              <AiOutlineExclamation size={18} />
            </div>
            <span
              className={`text-[14px] w-fit text-left ${isDark ? "text-red-200" : "text-red-600"}`}
            >
              {errors.email}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Subscription;
